export const loginStart = "LOGIN_START";
export const loginSuccess = "LOGIN_SUCCESS";
export const loginError = "LOGIN_ERROR";
export const refreshTokenStart = 'REFRESH_TOKEN_START';
export const refreshTokenSuccess = 'REFRESH_TOKEN_SUCCESS';
export const refreshTokenError = 'REFRESH_TOKEN_ERROR';
export const logoutSuccess = "LOGOUT_SUCCESS";
export const logoutFailure = "LOGOUT_FAILURE";